import axios from '../../../axiosInstance';

export const getStay = (id: any) => {
  return axios.get(`/locations/tag/${id}`);
};
